import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { User } from 'src/dto/User';
import { RootState } from 'src/redux/store';

interface UserState {
  user: User;
}

const initialState: UserState = {
  user: {
    company: {
      id: '',
      name: '',
    },
    email: '',
    first_name: '',
    id: '',
    incomplete: false,
    last_name: '',
    mfa_list: [],
    phone: '',
    phone_country_code: '',
    provider: '',
    roles: [],
    username: '',
  },
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser(state, action: PayloadAction<User>) {
      state.user = action.payload;
    },
  },
});

export const { setUser } = userSlice.actions;
export default userSlice.reducer;

export const selectUser = (state: RootState) => state.user.user;
